import { __decorate } from "tslib";
import { Component, Prop, Vue } from "../../vue";
import { get } from "lodash-es";
let SelectCgiForm = class SelectCgiForm extends Vue {
  get options() {
    const options = Object.entries(this.cgiMap).map(([key, info]) => {
      const desc = get(info, 'desc');
      const option = {
        value: key,
        label: desc ? `${key} - ${desc}` : key
      };
      return option;
    });
    return options;
  }
  created() {
    if (this.formData.cgi) {
      return;
    }
    if (this.options.some(item => item.value === 'request')) {
      this.formData.cgi = 'request';
    } else {
      var _this$options$0$value, _this$options;
      this.formData.cgi = (_this$options$0$value = (_this$options = this.options) === null || _this$options === void 0 || (_this$options = _this$options[0]) === null || _this$options === void 0 ? void 0 : _this$options.value) !== null && _this$options$0$value !== void 0 ? _this$options$0$value : '';
    }
  }
  render() {
    const h = arguments[0];
    const msg = h("div", [h("span", ["\u5F53\u524D\u6A21\u5F0F\u4E0B\uFF0C\u9009\u62E9\u7684\u63A5\u53E3\u4F1A\u6709\u5355\u72EC\u5BF9\u5E94\u7684query/body\u53C2\u6570\u53D8\u91CF\uFF0C\u65B9\u4FBF\u5728\u9875\u9762\u5F00\u53D1\u4E2D\u4F7F\u7528\u3002"]), h("br"), h("span", ["\u63A8\u8350\u4E00\u4E2A\u6570\u636E\u6E90\u5B9E\u4F8B\u8C03\u7528\u4E00\u4E2A\u63A5\u53E3\u3002"]), h("br"), h("span", ["\u6CE8\u610F: \u4E0D\u7BA1\u9009\u62E9\u7684\u662F\u54EA\u4E2A\u63A5\u53E3\uFF0C\u90FD\u662F\u7531", h("strong", ["request\u65B9\u6CD5"]), "\u8C03\u7528\u8BE5\u63A5\u53E3\uFF01"])]);
    return h("div", [h("a-form-model", [h("a-alert", {
      "attrs": {
        "message": msg
      }
    }), h("a-form-model-item", {
      "attrs": {
        "label": "选择调用的接口"
      }
    }, [h("a-select", {
      "attrs": {
        "options": this.options
      },
      "model": {
        value: this.formData.cgi,
        callback: $$v => {
          this.$set(this.formData, "cgi", $$v);
        }
      }
    })])])]);
  }
};
__decorate([Prop()], SelectCgiForm.prototype, "cgiMap", void 0);
__decorate([Prop()], SelectCgiForm.prototype, "formData", void 0);
SelectCgiForm = __decorate([Component({
  name: 'SelectCgiForm'
})], SelectCgiForm);
export default SelectCgiForm;
//# sourceMappingURL=index.js.map
